<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>
          {{ $t('ocspResponderList') }}
          <v-spacer></v-spacer>
          <v-text-field id="c2a55ec2" v-model="search" :label="$t('search')" append-icon="mdi-magnify" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          id="1be41c49"
          must-sort
          :search="search"
          :headers="headers"
          :items="ocspResponderList"
          :options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :loading-text="$t('dataTable.loadingPleaseWait')"
          :no-data-text="$t('dataTable.noDataAvailable')"
          :no-results-text="$t('dataTable.noMatchingRecordsFound')"
          :footer-props="{
            'items-per-page-text': $t('dataFooter.itemsPerPage'),
            'page-text': $t('dataFooter.pageText'),
            'items-per-page-options': [10,25,50]
          }"
        >
          <template v-slot:item.keyStoreActivated="{ item }">
            <v-icon :color="item.keyStoreActivated ? 'green' : 'red'">{{ item.keyStoreActivated ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
          </template>
          <template v-if="isAdmin" v-slot:item.action="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('38756a59', item.name)" icon :to="'ocspResponders/' + item.name + '/update'" v-on="on">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('update') }}</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('f1ce89a7', item.name)" icon v-on="on" @click="deleteOcspResponder(item.name)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('delete') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <fab-button v-if="isAdmin" id="2f81235c" tooltip-text="add" to="ocspResponders/add" />
    </v-flex>
  </v-layout>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'
import Role from '../../Role'
import signers from '../../api/signers'
import FabButton from '../../components/FabButton.vue'
import { showToastSuccess, showToastError, showConfirmationDialog } from '../../event-bus'

export default {
  name: 'OcspResponderList',

  components: {
    'fab-button': FabButton
  },

  data() {
    return {
      search: null,
      pagination: {
        sortBy: ['name']
      },
      ocspResponderList: [],
      totalItems: 0,
      loading: false,
      headers: [
        {
          text: this.$t('name'),
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t('keyStoreName'),
          value: 'keyStoreName',
          sortable: false
        },
        {
          text: this.$t('keyStoreActivated'),
          value: 'keyStoreActivated',
          sortable: false
        },
        {
          text: this.$t('actions'),
          value: 'action',
          sortable: false
        }
      ]
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isAdmin() {
      return this.hasRole(Role.ADMIN)
    }
  },

  watch: {
    search() {
      this.loading = true
      this.searchOcspResponderWatcher()
    },

    pagination() {
      this.searchOcspResponders()
    }
  },

  methods: {
    async searchOcspResponders() {
      this.loading = true
      try {
        let pageRequest = {
          'page-num': this.pagination.page,
          'page-size': this.pagination.itemsPerPage,
          'sort-field': this.pagination.sortBy[0],
          'sort-order': this.pagination.sortDesc[0] ? 'desc' : 'asc'
        }
        let page = await signers.listOcspResponders(this.search, pageRequest)
        this.ocspResponderList = page.content
        this.totalItems = page.total
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.loading = false
      }
    },

    searchOcspResponderWatcher: debounce(function() {
      this.searchOcspResponders()
    }, 500),

    async deleteOcspResponder(name) {
      let conf = await showConfirmationDialog(this.$t('confirmation'), this.$t('dialog.text.deleteItem'), true, this.$t('dialog.text.deleteItemKey'))
      if (!conf.confirmedValue) {
        return
      }

      try {
        await signers.deleteOcspResponder(name, conf.confirmedCheckboxValue)
        this.searchOcspResponders()
        showToastSuccess(this.$t('toastMessage.succesfullyDeleted'))
      } catch (error) {
        let errorMsg = this.$t('toastMessage.errorWhileRetrievingData')
        if (error.response != null) {
          switch (error.response.data.code) {
            case 'STILL_REFERENCED':
              errorMsg = this.$t('toastMessage.stillReferenced', { param: 'OcspResponder', param2: 'keyAlias' })
              break
            case 'GENERAL':
              errorMsg = '(' + error.response.data.code + ')' + ' ' + error.response.data.message
          }
        }
        showToastError(errorMsg)
      }
    }
  }
}
</script>

<style>
</style>
